import config from '../../config/index'

export const appUrl = config.appUrl
export const signupModalHref = '#signup-mod'
export const demoBookingUrl = 'https://meetings.hubspot.com/anthony-de-la-cruz?uuid=8a3781ef-d31a-4acc-bb91-08985edfff09'
